angular.module('leads').controller('TasksPmCtrl', [
  '$scope',
  '$stateParams',
  '$timeout',
  'Confirm',
  'Dialog',
  'GetToken',
  'GetUTypeToken',
  'LoggedUser',
  function(
    $scope,
    $stateParams,
    $timeout,
    Confirm,
    Dialog,
    GetToken,
    GetUTypeToken,
    LoggedUser
  ) {
    const alertTimeout = 250;

    $scope.apiUrl = '@@apiUrl';
    const loggedUser = LoggedUser.getData();
    const userType = loggedUser.type || '';

    let roleName = userType.startsWith('pm_')
      ? 'PM'
      : userType === 'superadmin'
      ? 'SA'
      : '';
    roleName = roleName ? `(${roleName})` : roleName;

    $scope.loggedUser = {
      _id: loggedUser._id,
      name: [loggedUser.first_name, loggedUser.last_name, roleName]
        .filter(i => i)
        .join(' ')
    };
    if (LoggedUser.isSalesDirector()) $scope.loggedUser.isSalesDirector = true;
    if (LoggedUser.isSuperAdmin()) $scope.loggedUser.isSuperAdmin = true;

    $scope.tasksPmApiUrl = '@@tasksPmApiUrl';
    $scope.tasksPmUrl = '@@tasksPmUrl';
    $scope.token = GetToken();
    $scope.xutype = GetUTypeToken();

    const { company, customer, workflow } = $stateParams;
    $scope.company = company;
    $scope.customer = customer;
    $scope.workflow = workflow;

    const dialog = new Dialog();
    const confirm = new Confirm();

    $scope.onError = (message = '') => {
      message && $timeout(dialog.error(message), alertTimeout);
    };

    $scope.onInfo = (message = '') => {
      message && $timeout(dialog.info(message), alertTimeout);
    };

    $scope.onSuccess = (message = '') => {
      message && $timeout(dialog.success(message), alertTimeout);
    };

    $scope.onConfirm = (message = '') => {
      if (!message)
        return Promise.reject(
          new Error('onConfirm was called without a message.')
        );

      return new Promise(resolve =>
        $timeout(() => {
          confirm.info(message).then(() => resolve());
        }, alertTimeout)
      );
    };
  }
]);
